export default function PHP_thread_id() {
  return (
    <div>
      <h1>PHP_thread_id</h1>
    </div>
  );
}
